<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetSourceList' }">预算源组</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="submitApproval('ruleDetailsForm')" :loading="btnLoading">保存并提交</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-7606" aria-describedby="el-collapse-content-7606">
                    <div role="button" id="el-collapse-head-7606" class="el-collapse-item__header is-active">
                        基本信息<i class="el-collapse-item__arrow el-icon-arrow-right is-active"></i>
                    </div>
                </div>
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleDetailsForm"
                    :label-position="labelPosition"
                    label-width="auto"
                    class="details"
                >
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="名称：" prop="name">
                                <el-input
                                    class="width-280"
                                    v-model="ruleForm.name"
                                    autocomplete="off"
                                    placeholder="如果不填名称，默认当前时间"
                                    clearable
                                    size="mini"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="版本时间：" prop="time">
                                <el-date-picker
                                    class="width-280"
                                    v-model="ruleForm.time"
                                    type="date"
                                    placeholder="请选择版本时间"
                                    value-format="yyyy-MM-dd"
                                    clearable
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="备注：" prop="remark">
                                <el-input
                                    class="width-280"
                                    :disabled="remarkDisabled"
                                    v-model="ruleForm.remark"
                                    autocomplete="off"
                                    placeholder="请输入备注"
                                    clearable
                                    size="mini"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                                <div class="read_only">
                                    {{ ruleForm.created_by ? ruleForm.created_by : '' }} 
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                                <div class="read_only">
                                    {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-collapse-item disabled title="预算源" name="1" v-if="type == 5 || type == 4 || type == 3">
                        <div class="details" v-for="(item, index) in ruleForm.budget_item_source" :key="index">
                            <el-row>
                                <el-col :span="7">
                                    <el-form-item
                                        label="预算项目："
                                        :prop="'budget_item_source.' + index + '.budget_item_rid'"
                                        :rules="{
                                            required: true,
                                            message: '预算项目不能为空',
                                            trigger: 'blur'
                                        }"
                                    >
                                        <el-select
                                            v-model="item.budget_item_name"
                                            filterable
                                            remote
                                            reserve-keyword
                                            placeholder="请输入预算项目名称搜索"
                                            :remote-method="remoteBudgetMethod"
                                            :loading="budgetLoading"
                                            size="mini"
                                            clearable
                                            value-key="rid"
                                            @change="budgetItemChange(item, index)"
                                            :disabled="item.budgetDisabled"
                                        >
                                            <el-option v-for="item in projectOptions" :key="item.rid" :label="item.name" :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item
                                        label="金额："
                                        :prop="'budget_item_source.' + index + '.amount'"
                                        :rules="{
                                            required: true,
                                            message: '金额不能为空',
                                            trigger: 'blur'
                                        }"
                                    >
                                        <el-input
                                            v-model="item.amount"
                                            autocomplete="off"
                                            placeholder="请输入金额"
                                            @keyup.native="item.amount = oninput(item.amount)"
                                            clearable
                                            :disabled="item.amountDisabled"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="备注：" :prop="'budget_item_source.' + index + '.remark'">
                                        <el-input :disabled="item.remarkDisabled" placeholder="请输入备注" v-model="item.remark"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <div class="margin-left-10">
                                        <el-button class="add_delete" type="primary" plain @click.prevent="add(item)">新增</el-button>
                                        <el-button class="btn_delete" type="danger" plain @click.prevent="removeDomain(item, index)"
                                            >删除</el-button
                                        >
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row v-if="item.typeShow">
                                <el-col :span="7">
                                    <el-form-item label="分配期间：" :prop="'budget_item_source.' + index + '.period'">
                                        <el-select
                                            filterable
                                            v-model="item.period"
                                            placeholder="请选择分配期间"
                                            clearable
                                            @change="periodItemChange(item, index)"
                                            :disabled="item.periodDisabled"
                                        >
                                            <el-option
                                                v-for="item in periodOption"
                                                :key="item.value"
                                                :label="item.name"
                                                :value="item.value"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6">
                                    <el-form-item label="生效日期：" :prop="'budget_item_source.' + index + '.effective_date'">
                                        <el-date-picker
                                            :picker-options="pickerOptions"
                                            v-model="item.effective_date"
                                            type="date"
                                            placeholder="请选择生效日期"
                                            value-format="yyyy-MM-dd"
                                            clearable
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="6"> &nbsp; </el-col>
                                <el-col :span="4"> &nbsp; </el-col>
                            </el-row>
                        </div>
                    </el-collapse-item>
                </el-form>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'budgetReportEdit',
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    var datetime = new Date();
                    return time.getTime() < Date.now() - 3600 * 1000 * 24 || time.getTime() > new Date(datetime.getFullYear() + 1, 0, 0); // 选当前时间之前的时间
                }
            },
            periodOption: [],
            btnLoading: false,
            rid: '',
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            labelPosition: 'right',
            hierarchyOptions: [],
            //基本信息内表单验证
            ruleForm: {
                name: '',
                time: '',
                remark: '',
                submission_hierarchy_rid: '',
                budget_item_source: []
            },
            rules: {
                // submission_hierarchy_rid: [{ required: true, message: '请选择提交人职位', trigger: 'blur' }],
                budget_item_source: {
                    budget_item_rid: [{ required: true, message: '请选择预算项目', trigger: 'blur' }],
                    amount: [{ required: true, message: '请输入金额', trigger: 'blur' }]
                }
            },
            statusOptions: [
                {
                    value: '草稿',
                    id: 1
                },
                {
                    value: '审批中',
                    id: 2
                }
            ],
            projectOptions: [],
            budgetLoading: false,
            page: 1,
            row: 25,
            name: '',
            remarkDisabled: false,
            headTitle: '',
            editType: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
        this.name = this.$route.query.name;
        this.editType = this.$route.query.editType;
        if (this.type == 1) {
            this.headTitle = '预算源组' + '编辑';
        } else if (this.type == 4) {
            if (this.editType == 1) {
                this.headTitle = '调整预算';
            } else {
                this.headTitle = '调零';
            }
        } else {
            this.headTitle = '预算源组' + '新增';
        }
    },
    mounted() {
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
            this.getList(0);
        } else if (this.type == 4) {
            if (this.editType == 2) {
                this.remarkDisabled = true;
                this.ruleForm = {
                    name: '',
                    time: '',
                    remark: this.$route.query.remark,
                    submission_hierarchy_rid: '',
                    budget_item_source: [
                        {
                            budget_item_name: this.name,
                            budget_item_rid: this.rid,
                            period: this.$route.query.period,
                            amount: this.$route.query.amount,
                            remark: this.$route.query.remark,
                            typeShow: false,
                            effective_date: this.$route.query.effective_date,
                            budgetDisabled: true,
                            periodDisabled: true,
                            remarkDisabled: true,
                            amountDisabled: true
                        }
                    ]
                };
            } else {
                this.remarkDisabled = false;
                if (this.$route.query.status == 1) {
                    var typeShow = true;
                } else {
                    var typeShow = false;
                }
                this.ruleForm = {
                    name: '',
                    time: '',
                    remark: '',
                    submission_hierarchy_rid: '',
                    budget_item_source: [
                        {
                            budget_item_name: this.name,
                            budget_item_rid: this.rid,
                            typeShow: typeShow,
                            period: '',
                            amount: '',
                            remark: '',
                            effective_date: '',
                            budgetDisabled: true
                        }
                    ]
                };
            }
        } else {
            this.ruleForm = {
                name: '',
                time: '',
                remark: '',
                submission_hierarchy_rid: '',
                budget_item_source: [
                    {
                        budget_item_rid: '',
                        period: '',
                        amount: '',
                        typeShow: false,
                        remark: '',
                        effective_date: ''
                    }
                ]
            };
        }
        // this.getHierarchies();
        this.getDropdownPeriod();
    },
    methods: {
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                budget_item_source_group_rid: this.rid,
                is_export: type_data
            };
            if (type_data == 0) {
                this.$api
                    .budgetItemSourceLists(params)
                    .then((res) => {
                        if (res.code == 0) {
                            var array = res.data.data;
                            for (let index = 0; index < array.length; index++) {
                                this.ruleForm.budget_item_source.push({
                                    budget_item_name: array[index].budget_item_name,
                                    budget_item_rid: array[index].budget_item_rid,
                                    period: array[index].period,
                                    amount: array[index].amount,
                                    remark: array[index].remark,
                                    effective_date: array[index].effective_date ? array[index].effective_date : ''
                                });
                            }
                        }
                    })
                    .catch((error) => {});
            } else {
                this.$api
                    .budgetItemSourceListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                    })
                    .catch((error) => {});
            }
        },
        //分配期间下拉
        getDropdownPeriod() {
            let params = {};
            this.$api
                .dropdownPeriod(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.periodOption = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取提交人职位
        // getHierarchies() {
        //     let params = {};
        //     this.$api
        //         .adminHierarchies(params)
        //         .then((res) => {
        //             if (res.code == 0) {
        //                 this.hierarchyOptions = res.data;
        //                 if (res.data.length != 0) {
        //                     this.ruleForm.submission_hierarchy_rid = res.data[0].value;
        //                 }
        //             }
        //         })
        //         .catch((error) => {
        //
        //         });
        // },
        //删除行 预算执行列表
        removeDomain(item, index) {
            if (index == 0) {
                if (this.editType == 2) {
                    this.$message({
                        message: '调零行不允许删除',
                        type: 'warning'
                    });
                } else {
                    if (this.ruleForm.budget_item_source.length == 1) {
                        this.$message({
                            message: '至少保留一条预算执行行',
                            type: 'error'
                        });
                    } else {
                        var index = this.ruleForm.budget_item_source.indexOf(item);
                        if (index !== -1) {
                            this.ruleForm.budget_item_source.splice(index, 1);
                        }
                    }
                }
            } else {
                if (this.ruleForm.budget_item_source.length == 1) {
                    this.$message({
                        message: '至少保留一条预算执行行',
                        type: 'error'
                    });
                } else {
                    var index = this.ruleForm.budget_item_source.indexOf(item);
                    if (index !== -1) {
                        this.ruleForm.budget_item_source.splice(index, 1);
                    }
                }
            }
        },
        //循环赋值每个 预算项目框
        budgetItemChange(item, index) {
            this.ruleForm.budget_item_source[index].budget_item_rid = item.budget_item_name.rid;
            if (item.budget_item_name.status == 1) {
                this.ruleForm.budget_item_source[index].typeShow = true;
            } else {
                this.ruleForm.budget_item_source[index].typeShow = false;
            }
        },
        //循环赋值每个 期间
        periodItemChange(item, index) {
            this.ruleForm.budget_item_source[index].period = item.period;
        },
        //新增预算执行列表
        add() {
            if (this.type == 4) {
                if (this.$route.query.status == 1) {
                    var typeShow = true;
                } else {
                    var typeShow = false;
                }
                this.ruleForm.budget_item_source.push({
                    budget_item_name: this.name,
                    budget_item_rid: this.rid,
                    typeShow: typeShow,
                    period: '',
                    amount: '',
                    remark: this.$route.query.remark,
                    effective_date: '',
                    budgetDisabled: true,
                    periodDisabled: false,
                    remarkDisabled: false,
                    amountDisabled: false
                });
            } else {
                this.ruleForm.budget_item_source.push({
                    budget_item_rid: '',
                    period: '',
                    amount: '',
                    remark: '',
                    effective_date: ''
                });
            }
        },
        //正则验证
        oninput(value) {
            //可以输入正负号，小数点，保留两位
            let str = value;
            if (isNaN(str) && !/^-$/.test(str)) {
                str = '';
            }
            if (!/^[+-]?\d*\.{0,1}\d{0,1}$/.test(str)) {
                str = str.replace(/\.\d{2,}$/, str.substr(str.indexOf('.'), 3));
            }
            return str;
        },
        //项目下拉
        remoteBudgetMethod(query) {
            if (query !== '') {
                this.budgetLoading = true;
                let params = {
                    key: query,
                    completion_date: this.ruleForm.time ? this.ruleForm.time : ''
                };
                this.$api
                    .searchBudgetItems(params)
                    .then((res) => {
                        if (res.code == 0) {
                            setTimeout(() => {
                                this.budgetLoading = false;
                                this.projectOptions = res.data;
                            }, 200);
                        } else {
                            this.projectOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.budgetLoading = false;
                this.projectOptions = [];
            }
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetSourceList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetItemSourceGroupDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        if (this.type == 5) {
                            this.ruleForm.name = '';
                        } else if (this.type == 1) {
                            this.ruleForm.name = res.data.name;
                        }
                        this.ruleForm.time = res.data.time;
                        this.ruleForm.remark = res.data.remark;
                        // this.getHierarchies();
                        this.ruleForm.updated_at = res.data.updated_at;
                        this.ruleForm.created_by = res.data.created_by;
                        this.ruleForm.created_at = res.data.created_at;
                        this.ruleForm.updated_by = res.data.updated_by;
                    }
                })
                .catch((error) => {});
        },
        // 保存
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.ruleForm.approval_status = 1;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        // 提交
        submitApproval(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.ruleForm.approval_status = 2;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                name: this.ruleForm.name,
                time: this.ruleForm.time ? this.ruleForm.time : '',
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid,
                budget_item_source: this.ruleForm.budget_item_source,
                approval_status: this.ruleForm.approval_status,
                rid: this.rid
            };
            this.$api
                .budgetItemSourceGroupUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                name: this.ruleForm.name,
                time: this.ruleForm.time ? this.ruleForm.time : '',
                remark: this.ruleForm.remark ? this.ruleForm.remark : '',
                submission_hierarchy_rid: this.ruleForm.submission_hierarchy_rid,
                budget_item_source: this.ruleForm.budget_item_source,
                approval_status: this.ruleForm.approval_status
            };
            this.$api
                .budgetItemSourceGroupInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
.el-collapse {
    border-bottom: none;
    padding-top: 60px;
}

div .el-select {
    display: block;
}
.margin-left-10 {
    margin-left: 10px;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
.width-280 {
    width: 280px !important;
}
</style>